import { MdSearch } from 'react-icons/md';

import TabFilters from '@/components/common/TabFilters';
import SafeInput from '@/components/inputs/SafeInput';
import useLanguage from '@/utils/hooks/useLanguage';
import useMarketList from '@/utils/hooks/useMarketList';
import { useDebouncedSize } from '@/utils/hooks/useSize';
import { useRef } from 'react';

export interface MarketListProps {
    isTraderMode?: boolean;
    onClick?: () => void;
}

export enum MarketListFilter {
    'All' = 0,
    'FX' = 1,
    'Crypto' = 2,
    'Index CFD' = 3,
    'Comm CFD' = 4,
    'Futures CFD' = 5
}

export default function MarketList(props: MarketListProps) {
    const marketListBodyRef = useRef<HTMLDivElement>(null);
    const size = useDebouncedSize(marketListBodyRef);

    const {
        marketListFilters,
        marketListFilter,
        setMarketListFilter,
        setFilter,
        hasInstruments: {
            hasFxInstruments,
            hasCryptoInstruments,
            hasIndexInstruments,
            hasCommInstruments,
            hasFuturesInstruments
        },
        MarketList
    } = useMarketList({ ...props, parentSize: size?.width });

    const lang = useLanguage();

    return (
        <div ref={marketListBodyRef} className="h-full w-full flex flex-col">
            <TabFilters.Main>
                <TabFilters.Filter
                    selectedFilter={marketListFilter}
                    setSelectedFilter={setMarketListFilter}
                    filter={marketListFilters[0]}
                />
                {hasFxInstruments && (
                    <TabFilters.Filter
                        selectedFilter={marketListFilter}
                        setSelectedFilter={setMarketListFilter}
                        filter={marketListFilters[1]}
                    />
                )}
                {hasCryptoInstruments && (
                    <TabFilters.Filter
                        selectedFilter={marketListFilter}
                        setSelectedFilter={setMarketListFilter}
                        filter={marketListFilters[2]}
                    />
                )}
                {hasIndexInstruments && (
                    <TabFilters.Filter
                        selectedFilter={marketListFilter}
                        setSelectedFilter={setMarketListFilter}
                        filter={marketListFilters[3]}
                    />
                )}
                {hasCommInstruments && (
                    <TabFilters.Filter
                        selectedFilter={marketListFilter}
                        setSelectedFilter={setMarketListFilter}
                        filter={marketListFilters[4]}
                    />
                )}
                {hasFuturesInstruments && (
                    <TabFilters.Filter
                        selectedFilter={marketListFilter}
                        setSelectedFilter={setMarketListFilter}
                        filter={marketListFilters[5]}
                    />
                )}
            </TabFilters.Main>
            <div className="p-2">
                <SafeInput
                    placeholder={lang.common.search}
                    icon={<MdSearch />}
                    onChange={(e) => setFilter(e.target.value)}
                />
            </div>

            <div className="relative self-stretch grow basis-full">
                <MarketList />
            </div>
        </div>
    );
}
